(function () {
  var modal = document.getElementById('tunnelModal');
  if (!modal) return;

  var dataNode = document.getElementById('tunnelBraseroData');
  var tunnelData = null;
  try {
    tunnelData = JSON.parse(dataNode.textContent);
  } catch (err) {
    console.warn('[tunnel] JSON parse error', err);
    return;
  }

  normalizeTunnelPreorderData(tunnelData);

  var i18nNode = document.getElementById('tunnelI18nData');
  var I18N = {};
  try {
    I18N = JSON.parse(i18nNode.textContent);
  } catch (err) {
    console.warn('[tunnel] i18n JSON parse error', err);
  }

  function t(key, vars) {
    var str = I18N[key] || '';
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        str = str.split('%{' + k + '}').join(vars[k]);
      });
    }
    return str;
  }

  function plural(count, oneKey, otherKey, vars) {
    vars = vars || {};
    vars.count = count;
    return t(count === 1 ? oneKey : otherKey, vars);
  }

  var STEP_KEYS = ['brasero', 'cuisine', 'confort', 'entretien', 'recap'];
  var STEP_HEADLINES = {
    brasero: t('step_brasero_headline'),
    cuisine: t('step_cuisine_headline'),
    confort: t('step_confort_headline'),
    entretien: t('step_entretien_headline'),
    recap: t('step_recap_headline')
  };
  var STEP_LABELS = {
    brasero: t('step_brasero_label'),
    cuisine: t('step_cuisine_label'),
    confort: t('step_confort_label'),
    entretien: t('step_entretien_label'),
    recap: t('step_recap_label')
  };

  var SWISS_MARKET_HANDLE = 'ch';
  var DIAMETER_95_HANDLE = 'brasero-suak-premium-95-corten';
  var DIAMETER_95_DEFAULT = '44';
  var DIAMETER_95_SWISS_NOIR = '40';

  var headlineEl = modal.querySelector('[data-tunnel-headline]');
  var itemsWrap = modal.querySelector('[data-tunnel-items]');
  var breadcrumbEl = modal.querySelector('[data-tunnel-breadcrumb]');
  var progressBar = modal.querySelector('[data-tunnel-progress]');
  var visualMain = modal.querySelector('[data-tunnel-visual-main]');
  var visualStack = modal.querySelector('[data-tunnel-visual-stack]');
  var pictosMobile = modal.querySelector('[data-tunnel-pictos-mobile]');
  var pictosMobileItems = pictosMobile ? Array.prototype.slice.call(pictosMobile.querySelectorAll('[data-tunnel-picto-mobile-item]')) : [];
  var pictosDesktop = modal.querySelector('[data-tunnel-pictos-desktop]');
  var btnPrev = modal.querySelector('[data-tunnel-prev]');

function adaptPrevLabel() {
  if (btnPrev.hidden) return;
  btnPrev.textContent = t('add_to_cart');
  requestAnimationFrame(function () {
    var lineHeight = parseInt(getComputedStyle(btnPrev).lineHeight, 10) || 20;
    var paddingTop = parseInt(getComputedStyle(btnPrev).paddingTop, 10) || 0;
    var paddingBottom = parseInt(getComputedStyle(btnPrev).paddingBottom, 10) || 0;
    var singleLineHeight = lineHeight + paddingTop + paddingBottom;
    if (btnPrev.offsetHeight > singleLineHeight + 2) {
      btnPrev.textContent = t('add_to_cart_short');
    }
  });
}
  var btnNext = modal.querySelector('[data-tunnel-next]');
  var totalTextEl = modal.querySelector('[data-tunnel-total-text]');
  var preorderNotice = modal.querySelector('[data-preorder-notice]');
  var preorderNoticeCloseBtn = modal.querySelector('[data-preorder-notice-close]');
  var discountHintEl = modal.querySelector('[data-tunnel-discount-hint]');
  var discountLabelEl = modal.querySelector('[data-tunnel-discount-label]');
  var discountFillEl = modal.querySelector('[data-tunnel-discount-fill]');
  var discountMilestonesEl = modal.querySelector('[data-tunnel-discount-milestones]');

  var state = {
    stepIndex: 0,
    braseroHandle: null,
    colorMode: 'corten',
    wheelsMode: 'pieds',
    braseroQty: 1,
    selections: new Map(),
    stack: [],
    recapExpanded: {},
    activeVariant: {},
    preorderNoticeShown: false
  };

  var isAdding = false;
  var lastOpener = null;

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  function cleanProductName(name) {
    if (!name) return '';
    var idx = name.indexOf('—');
    return idx > 0 ? name.slice(0, idx).trim() : name.trim();
  }

  function variantLabel(variant) {
    if (!variant.title || variant.title === 'Default Title') return '';
    return variant.title.trim();
  }

  var MONEY_CANARY_INT = '12345';
  var MONEY_CANARY_FRAC = '00';

  function buildMoneyFormat() {
    var fallback = {
      prefix: '',
      suffix: ' ' + (tunnelData.currencySymbol || '€'),
      thousandsSep: '',
      decimalSep: '.',
      decimalPlaces: 2
    };

    var plain = tunnelData.moneyFormatPlain;
    var full = tunnelData.moneyFormat;
    if (!plain || !full) return fallback;

    var digitsOnly = plain.replace(/\D/g, '');
    if (digitsOnly.indexOf(MONEY_CANARY_INT) !== 0) return fallback;

    var hasDecimals = digitsOnly.length === MONEY_CANARY_INT.length + MONEY_CANARY_FRAC.length &&
      digitsOnly.slice(-MONEY_CANARY_FRAC.length) === MONEY_CANARY_FRAC;

    var decimalSep = '.';
    var decimalPlaces = 0;
    var integerPart = plain;

    if (hasDecimals) {
      decimalPlaces = MONEY_CANARY_FRAC.length;
      var splitIdx = plain.length - decimalPlaces;
      decimalSep = plain.charAt(splitIdx - 1);
      integerPart = plain.slice(0, splitIdx - 1);
    }

    var thousandsMatch = integerPart.match(/\D/);
    var thousandsSep = thousandsMatch ? thousandsMatch[0] : '';

    var plainIndex = full.indexOf(plain);
    if (plainIndex === -1) return fallback;

    var stripTags = function (str) { return str.replace(/<[^>]*>/g, ''); };

    return {
      prefix: stripTags(full.slice(0, plainIndex)),
      suffix: stripTags(full.slice(plainIndex + plain.length)),
      thousandsSep: thousandsSep,
      decimalSep: decimalSep,
      decimalPlaces: decimalPlaces
    };
  }

  var moneyFormat = buildMoneyFormat();
  moneyFormat.decimalPlaces = 0;

  function money(n) {
    var factor = Math.pow(10, moneyFormat.decimalPlaces);
    var parts = (Math.round(n * factor) / factor).toFixed(moneyFormat.decimalPlaces).split('.');
    var intPart = parts[0];
    if (moneyFormat.thousandsSep) {
      intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, moneyFormat.thousandsSep);
    }
    var numStr = moneyFormat.decimalPlaces > 0 ? intPart + moneyFormat.decimalSep + parts[1] : intPart;
    return moneyFormat.prefix + numStr + moneyFormat.suffix;
  }

  function deltaLabel(price, refPrice) {
    var factor = Math.pow(10, moneyFormat.decimalPlaces);
    var diff = Math.round((price - refPrice) * factor) / factor;
    if (diff === 0) return '';
    return (diff > 0 ? ' (+' : ' (−') + money(Math.abs(diff)) + ')';
  }

  function colorImage(colorData, wheels) {
    return wheels === 'roulettes' ? (colorData.roulettesImage || colorData.piedsImage) : colorData.piedsImage;
  }

  function setImageSrc(imgEl, src, alt) {
    if (!imgEl || !src) return;
    if (imgEl.getAttribute('data-current-src') === src) return;

    var token = (parseInt(imgEl.getAttribute('data-load-token'), 10) || 0) + 1;
    imgEl.setAttribute('data-load-token', String(token));

    var preloader = new Image();

    function apply() {
      if (imgEl.getAttribute('data-load-token') !== String(token)) return;
      imgEl.src = src;
      if (alt !== undefined) imgEl.setAttribute('alt', alt || '');
      imgEl.setAttribute('data-current-src', src);
    }

    preloader.onload = apply;
    preloader.onerror = apply;
    preloader.src = src;

    if (preloader.complete) apply();
  }

    function setVisualMain(src, alt) {
    setImageSrc(visualMain, src, alt);
  }

  function updatePictos() {
    var model = currentBrasero();
    var diameter = model ? extractDiameterNumber(model.title) : null;
    var desktopSrc = diameter && tunnelData.pictosDesktop ? tunnelData.pictosDesktop[diameter] : null;
    var mobileSrcs = diameter && tunnelData.pictosMobile ? tunnelData.pictosMobile[diameter] : null;
    var show = currentStepKey() === 'brasero';

    if (pictosDesktop) {
      if (show && desktopSrc) {
        setImageSrc(pictosDesktop, desktopSrc, cleanProductName(model.title));
        pictosDesktop.hidden = false;
        requestAnimationFrame(function () {
          if (!pictosDesktop.hidden) pictosDesktop.classList.add('is-visible');
        });
      } else {
        pictosDesktop.classList.remove('is-visible');
        pictosDesktop.hidden = true;
      }
    }

    if (pictosMobile) {
      if (show && mobileSrcs && mobileSrcs.length) {
        pictosMobileItems.forEach(function (img, i) {
          if (mobileSrcs[i]) setImageSrc(img, mobileSrcs[i], '');
        });
        pictosMobile.hidden = false;
        requestAnimationFrame(function () {
          if (!pictosMobile.hidden) pictosMobile.classList.add('is-visible');
        });
      } else {
        pictosMobile.classList.remove('is-visible');
        pictosMobile.hidden = true;
      }
    }
  }

  function variantOptionsMap(variant) {
    var map = {};
    (variant.options || []).forEach(function (o) { map[o.name] = o.value; });
    return map;
  }

  function optionGroups(variants) {
    var order = [];
    var valuesByName = {};
    variants.forEach(function (v) {
      (v.options || []).forEach(function (o) {
        if (!valuesByName[o.name]) { valuesByName[o.name] = []; order.push(o.name); }
        if (valuesByName[o.name].indexOf(o.value) === -1) valuesByName[o.name].push(o.value);
      });
    });
    return order
      .map(function (name) { return { name: name, values: valuesByName[name] }; })
      .filter(function (group) { return group.values.length > 1; });
  }

  function findVariantByOptions(variants, selections) {
    return variants.find(function (v) {
      var map = variantOptionsMap(v);
      return Object.keys(selections).every(function (name) { return map[name] === selections[name]; });
    }) || null;
  }

  var preorderCampaignMap = null;

  function getPreorderCampaignMap() {
    if (preorderCampaignMap) return preorderCampaignMap;
    preorderCampaignMap = {};
    try {
      var embed = document.querySelector('essential-preorder-app-embed');
      var raw = embed && embed.getAttribute('preorder-app-data');
      if (!raw) return preorderCampaignMap;
      var data = JSON.parse(raw);
      (data.preorderCampaigns || []).forEach(function (campaign) {
        (campaign.sellingPlanIds || []).forEach(function (planId) {
          preorderCampaignMap[planId] = campaign;
        });
      });
    } catch (err) {
      console.warn('[tunnel] preorder campaign map error', err);
    }
    return preorderCampaignMap;
  }

  function campaignAppliesToMarket(campaign, marketId) {
    var content = campaign.content || {};
    if (content.marketType !== 'SPECIFIC') return true;
    if (!marketId) return true;
    var marketGid = 'gid://shopify/Market/' + marketId;
    return (content.specificMarkets || []).some(function (m) { return m.shopifyId === marketGid; });
  }

  function clearPreorderIfIneligible(obj, preorderKey, sellingPlanKey, marketId) {
    if (!obj || !obj[preorderKey]) return;
    var campaignMap = getPreorderCampaignMap();
    var planId = obj[sellingPlanKey];
    var campaign = planId ? campaignMap[planId] : null;
    if (!campaign || !campaignAppliesToMarket(campaign, marketId)) {
      obj[preorderKey] = false;
      obj[sellingPlanKey] = null;
    }
  }

  function normalizeTunnelPreorderData(data) {
    var marketId = data.marketId;
    (data.braseros || []).forEach(function (brasero) {
      var colors = brasero.colors || {};
      Object.keys(colors).forEach(function (colorKey) {
        var colorData = colors[colorKey];
        clearPreorderIfIneligible(colorData, 'piedsPreorder', 'piedsSellingPlanId', marketId);
        clearPreorderIfIneligible(colorData, 'roulettesPreorder', 'roulettesSellingPlanId', marketId);

        var categories = colorData.categories || {};
        Object.keys(categories).forEach(function (categoryKey) {
          (categories[categoryKey] || []).forEach(function (item) {
            clearPreorderIfIneligible(item, 'preorder', 'sellingPlanId', marketId);
            (item.variants || []).forEach(function (variant) {
              clearPreorderIfIneligible(variant, 'preorder', 'sellingPlanId', marketId);
            });
          });
        });
      });
    });
  }

  function preorderPropertiesForPlan(sellingPlanId) {
    var campaign = getPreorderCampaignMap()[sellingPlanId];
    if (!campaign) return null;
    var props = { '_essential_preorder_campaign_id': campaign.id };
    var content = campaign.content || {};
    if (content.cartNoteKey && content.cartNoteText) {
      props[content.cartNoteKey] = content.cartNoteText;
    }
    return props;
  }

  function localizedPreorderDelivery(cartNoteText) {
  if (!cartNoteText) return null;

  var text = String(cartNoteText).trim();

  var match = text.match(
    /entre\s+le\s+(\d{1,2})(?:er)?\s+et\s+le\s+(\d{1,2})\s+([a-zàâäéèêëîïôöùûüÿç-]+)\s+(\d{4})/i
  );

  if (!match) return null;

  var startDay = Number(match[1]);
  var endDay = Number(match[2]);
  var monthName = match[3].toLowerCase();
  var year = Number(match[4]);

  var monthMap = {
    janvier: 0,
    février: 1,
    fevrier: 1,
    mars: 2,
    avril: 3,
    mai: 4,
    juin: 5,
    juillet: 6,
    août: 7,
    aout: 7,
    septembre: 8,
    octobre: 9,
    novembre: 10,
    décembre: 11,
    decembre: 11
  };

  var monthIndex = monthMap[monthName];

  if (monthIndex === undefined) {
    return null;
  }

  var startDate = new Date(year, monthIndex, startDay);
  var endDate = new Date(year, monthIndex, endDay);

  if (
    isNaN(startDate.getTime()) ||
    isNaN(endDate.getTime())
  ) {
    return null;
  }

  var locale = I18N.locale || 'fr';
  if (locale === 'sr') locale = 'sr-Latn';

  var dateFormatter = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  var startText = dateFormatter.format(startDate);
  var endText = dateFormatter.format(endDate);

  if (/^fr(?:-|$)/i.test(locale) && startDay === 1) {
    startText = startText.replace(/^1\b/, '1er');
  }

  if (/^en(?:-|$)/i.test(locale) && startDate.getMonth() === endDate.getMonth()) {
    var englishStart = new Intl.DateTimeFormat(locale, {
      month: 'long',
      day: 'numeric'
    }).format(startDate);

    var englishEnd = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      year: 'numeric'
    }).format(endDate);

    startText = englishStart;
    endText = englishEnd;
  }

  return t('preorder_delivery_between', {
    start: startText,
    end: endText
  });
}

function preorderInfoForPlan(sellingPlanId) {
  var campaign = getPreorderCampaignMap()[sellingPlanId];
  if (!campaign) return null;

  var content = campaign.content || {};
  var parts = [];

  if (
    content.paymentType === 'PARTIAL' &&
    content.paymentCheckoutChargeType === 'PERCENTAGE' &&
    content.paymentCheckoutChargeValue
  ) {
    parts.push(
      t('partial_payment_percent', {
        percent: content.paymentCheckoutChargeValue
      })
    );
  } else if (content.paymentType === 'PARTIAL') {
    parts.push(t('partial_payment'));
  }

  if (content.cartNoteText) {
    var deliveryText = localizedPreorderDelivery(content.cartNoteText);

    if (deliveryText) {
      parts.push(deliveryText);
    } else {
      parts.push(
        content.cartNoteText.charAt(0).toUpperCase() +
        content.cartNoteText.slice(1)
      );
    }
  }

  return parts.length ? parts.join(' · ') : null;
}

  function renderPreorderBadge(sellingPlanId) {
    var info = sellingPlanId ? preorderInfoForPlan(sellingPlanId) : null;
    var infoMarkup = info
      ? '<button type="button" class="tunnel-card__info-btn" data-info-trigger aria-label="' + escapeHtml(t('preorder_details')) + '">' +
        '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.4"/><circle cx="8" cy="4.6" r="0.9" fill="currentColor"/><rect x="7.15" y="6.8" width="1.7" height="5" rx="0.6" fill="currentColor"/></svg>' +
        '</button>' +
        '<span class="tunnel-card__info-tooltip" data-info-tooltip hidden>' + escapeHtml(info) + '</span>'
      : '';
    return '<span class="tunnel-card__badge">' + escapeHtml(t('preorder_badge')) + infoMarkup + '</span>';
  }

  function closeAllInfoTooltips() {
    modal.querySelectorAll('[data-info-tooltip]').forEach(function (tip) {
      tip.hidden = true;
    });
  }

  function bindPreorderInfo(root) {
    root.querySelectorAll('[data-info-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var tooltip = btn.nextElementSibling;
        if (!tooltip) return;
        var willOpen = tooltip.hidden;
        closeAllInfoTooltips();
        closeAllDropdowns();
        tooltip.hidden = !willOpen;
      });
    });
  }

  function closeAllDropdowns() {
    modal.querySelectorAll('[data-dropdown-list]').forEach(function (list) {
      list.hidden = true;
      list.classList.remove('is-open');
    });
    modal.querySelectorAll('.tunnel-card.is-dropdown-open').forEach(function (card) {
      card.classList.remove('is-dropdown-open');
    });
  }

  function positionDropdown(list) {
    list.classList.remove('is-anchored-right', 'is-anchored-top');
    var rect = list.getBoundingClientRect();
    var viewportWidth = document.documentElement.clientWidth;
    var viewportHeight = document.documentElement.clientHeight;
    if (rect.right > viewportWidth - 8) {
      list.classList.add('is-anchored-right');
    }
    if (rect.bottom > viewportHeight - 8) {
      list.classList.add('is-anchored-top');
    }
  }

  function bindDropdown(wrap, onSelect) {
    var trigger = wrap.querySelector('[data-dropdown-trigger]');
    var list = wrap.querySelector('[data-dropdown-list]');
    var card = wrap.closest('.tunnel-card');
    if (!trigger || !list) return;

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = list.hidden;
      closeAllDropdowns();
      list.hidden = !willOpen;
      if (willOpen) positionDropdown(list);
      list.classList.toggle('is-open', willOpen);
      if (card) card.classList.toggle('is-dropdown-open', willOpen);
    });

    list.querySelectorAll('[data-value]').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.stopPropagation();
        if (opt.getAttribute('aria-disabled') === 'true') return;
        list.hidden = true;
        if (card) card.classList.remove('is-dropdown-open');
        onSelect(opt.getAttribute('data-value'));
      });
    });
  }

  function currentBrasero() {
    return tunnelData.braseros.find(function (b) { return b.handle === state.braseroHandle; }) || null;
  }

  function currentColorData() {
    var model = currentBrasero();
    if (!model) return null;
    return model.colors[state.colorMode] || model.colors.corten || null;
  }

  function selectBrasero(handle, opts) {
    opts = opts || {};
    var modelChanged = state.braseroHandle !== handle;
    var colorChanged = 'color' in opts && opts.color !== state.colorMode;
    if (modelChanged || colorChanged) {
      state.selections.clear();
      state.stack = [];
    }
    if (modelChanged) {
      state.colorMode = 'corten';
      state.wheelsMode = 'pieds';
    }
    state.braseroHandle = handle;
    if ('color' in opts) state.colorMode = opts.color;
    if ('wheels' in opts) state.wheelsMode = opts.wheels;
  }

  function extractDiameter(title) {
    var matches = String(title).match(/\d+/g);
    return matches ? 'Ø ' + matches[matches.length - 1] + ' cm' : '';
  }

  function extractDiameterNumber(str) {
    var matches = String(str).match(/\d+/g);
    return matches ? matches[matches.length - 1] : null;
  }

  function currentStepKey() {
    return STEP_KEYS[state.stepIndex];
  }

  function isRecap() {
    return currentStepKey() === 'recap';
  }

  function braseroIsPreorder(colorData) {
    return state.wheelsMode === 'roulettes' ? colorData.roulettesPreorder : colorData.piedsPreorder;
  }

  function openPreorderNotice() {
    if (!preorderNotice) return;
    preorderNotice.hidden = false;
    preorderNotice.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        preorderNotice.classList.add('is-open');
      });
    });
  }

  function closePreorderNotice() {
    if (!preorderNotice) return;
    preorderNotice.classList.remove('is-open');
    preorderNotice.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      preorderNotice.hidden = true;
    }, 220);
  }

  function maybeShowPreorderNotice(item) {
    if (state.preorderNoticeShown || !item.sellingPlanId) return;
    var colorData = currentColorData();
    if (!colorData || braseroIsPreorder(colorData)) return;
    state.preorderNoticeShown = true;
    openPreorderNotice();
  }

  function dedupeByProduct(items, pickFn) {
    var byProduct = {};
    items.forEach(function (it) {
      byProduct[it.productHandle] = byProduct[it.productHandle] || [];
      byProduct[it.productHandle].push(it);
    });

    var filtered = [];
    Object.keys(byProduct).forEach(function (handle) {
      var group = byProduct[handle];
      filtered.push(group.length <= 1 ? group[0] : pickFn(group));
    });
    return filtered;
  }

    function categoryItems(colorData, categoryKey) {
    var items = (colorData.categories && colorData.categories[categoryKey]) || [];

    if (colorData.productHandle === DIAMETER_95_HANDLE && categoryKey === 'cuisine') {
      var targetDiameter = DIAMETER_95_DEFAULT;
      if (tunnelData.market === SWISS_MARKET_HANDLE && state.colorMode === 'noir') {
        targetDiameter = DIAMETER_95_SWISS_NOIR;
      }
      return dedupeByProduct(items, function (group) {
        var match = group.find(function (it) { return extractDiameterNumber(it.variantTitle) === targetDiameter; });
        return match || group[0];
      });
    }

    return dedupeByProduct(items, function (group) {
      var withNativeOrder = group.filter(function (it) { return Array.isArray(it.variants) && it.variants.length; });
      if (!withNativeOrder.length) return group[0];
      var nativeFirstId = withNativeOrder[0].variants[0].id;
      var match = group.find(function (it) { return it.variantId === nativeFirstId; });
      return match || group[0];
    });
  }

  var STACK_MOBILE_CAP = 9;

  function stackItemHtml(entry) {
    return (
      '<div class="tunnel-visual__stack-item" title="' + escapeHtml(cleanProductName(entry.title)) + '">' +
      '<img src="' + escapeHtml(entry.image) + '" alt="' + escapeHtml(entry.title) + '" loading="lazy" decoding="async">' +
      '</div>'
    );
  }

  function renderStackItems() {
    var isDesktop = window.matchMedia('(min-width: 990px)').matches;
    if (isDesktop || state.stack.length <= STACK_MOBILE_CAP) {
      return state.stack.map(stackItemHtml).join('');
    }
    var visibleCount = STACK_MOBILE_CAP - 1;
    var hiddenCount = state.stack.length - visibleCount;
    return state.stack.slice(0, visibleCount).map(stackItemHtml).join('') +
      '<div class="tunnel-visual__stack-item tunnel-visual__stack-item--overflow"><span class="tunnel-visual__stack-overflow">+' + hiddenCount + '</span></div>';
  }

  function renderVisual() {
    updateTotal();
    updatePictos();
    var step = currentStepKey();

    if (step === 'brasero') {
      var selectedModel = currentBrasero();
      var selectedColorData = currentColorData();
      if (selectedModel && selectedColorData) {
        setVisualMain(colorImage(selectedColorData, state.wheelsMode), selectedModel.title);
      } else {
        setVisualMain(tunnelData.heroImage, '');
      }
      visualStack.innerHTML = '';
      return;
    }

    var brasero = currentBrasero();
    var colorData = currentColorData();
    if (brasero && colorData) {
      setVisualMain(colorImage(colorData, state.wheelsMode), brasero.title);
    }

    visualStack.innerHTML = renderStackItems();
  }

  function pushToStack(variantId, image, title) {
    if (state.stack.some(function (e) { return e.variantId === variantId; })) return;
    state.stack.push({ variantId: variantId, image: image, title: title });
  }

  function removeFromStack(variantId) {
    state.stack = state.stack.filter(function (e) { return e.variantId !== variantId; });
  }

  function updateProgress() {
    var total = STEP_KEYS.length;
    var pct = (state.stepIndex / (total - 1)) * 100;
    progressBar.style.width = Math.max(0, Math.min(100, pct)) + '%';
  }

  function goToStep(i) {
    if (i === state.stepIndex) return;
    if (i > 0 && !state.braseroHandle) return;
    if (isAdding) return;
    state.stepIndex = i;
    renderStep();
  }

  function renderBreadcrumb() {
    if (!breadcrumbEl) return;

    breadcrumbEl.innerHTML = STEP_KEYS.map(function (key, i) {
      var reachable = i === 0 || !!state.braseroHandle;
      return (
        '<button type="button" class="tunnel-breadcrumb__item' + (i === state.stepIndex ? ' is-active' : '') + '"' +
        ' data-step-index="' + i + '"' + (reachable ? '' : ' disabled') + '>' +
        escapeHtml(STEP_LABELS[key]) +
        '</button>'
      );
    }).join('');

    breadcrumbEl.querySelectorAll('[data-step-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goToStep(Number(btn.getAttribute('data-step-index')));
      });
    });
  }

  function updateBraseroCard(card, model) {
    var isActive = model.handle === state.braseroHandle;
    var color = isActive ? state.colorMode : 'corten';
    var colorData = model.colors[color] || model.colors.corten;
    var wheels = isActive ? state.wheelsMode : 'pieds';
    var price = wheels === 'roulettes' ? colorData.roulettesPrice : colorData.piedsPrice;
    var isPreorder = wheels === 'roulettes' ? colorData.roulettesPreorder : colorData.piedsPreorder;
    var sellingPlanId = wheels === 'roulettes' ? colorData.roulettesSellingPlanId : colorData.piedsSellingPlanId;

    card.classList.toggle('is-selected', isActive);
    card.setAttribute('aria-pressed', isActive);

    var imgEl = card.querySelector('.tunnel-card__media img');
    if (imgEl) {
      setImageSrc(imgEl, colorImage(colorData, wheels), model.title);
    }

    var priceEl = card.querySelector('.tunnel-card__price');
    if (priceEl) {
      priceEl.innerHTML = money(price) + '<span class="tunnel-card__price-sep">·</span>' + escapeHtml(extractDiameter(model.title));
    }

    ['corten', 'noir'].forEach(function (key) {
      var opt = card.querySelector('[data-value="color|||' + key + '"]');
      if (!opt) return;
      var otherColorData = model.colors[key];
      var otherPrice = wheels === 'roulettes' ? otherColorData.roulettesPrice : otherColorData.piedsPrice;
      var label = key === 'corten' ? t('corten') : t('noir');
      opt.classList.toggle('is-selected', color === key);
      opt.textContent = label + (color === key ? '' : deltaLabel(otherPrice, price));
    });

    var optPieds = card.querySelector('[data-value="wheels|||pieds"]');
    var optRoulettes = card.querySelector('[data-value="wheels|||roulettes"]');
    if (optPieds) {
      optPieds.classList.toggle('is-selected', wheels === 'pieds');
      optPieds.textContent = t('pieds') + (wheels === 'pieds' ? '' : deltaLabel(colorData.piedsPrice, price));
    }
    if (optRoulettes) {
      optRoulettes.classList.toggle('is-selected', wheels === 'roulettes');
      optRoulettes.textContent = t('roulettes') + (wheels === 'roulettes' ? '' : deltaLabel(colorData.roulettesPrice, price));
    }

    var mediaEl = card.querySelector('.tunnel-card__media');
    var existingBadge = card.querySelector('.tunnel-card__badge');
    if (isPreorder && mediaEl) {
      if (existingBadge) existingBadge.remove();
      mediaEl.insertAdjacentHTML('afterbegin', renderPreorderBadge(sellingPlanId));
      bindPreorderInfo(card);
    } else if (!isPreorder && existingBadge) {
      existingBadge.remove();
    }
  }

  function syncBraseroCards() {
    itemsWrap.querySelectorAll('.tunnel-card').forEach(function (card) {
      var b = tunnelData.braseros.find(function (x) { return x.handle === card.getAttribute('data-handle'); });
      if (b) updateBraseroCard(card, b);
    });
  }

  function renderBraseroStep() {
    itemsWrap.className = 'tunnel-screen__items';

    itemsWrap.innerHTML = tunnelData.braseros.map(function (model) {
      var isActive = model.handle === state.braseroHandle;
      var color = isActive ? state.colorMode : 'corten';
      var colorData = model.colors[color] || model.colors.corten;
      var wheels = isActive ? state.wheelsMode : 'pieds';
      var price = wheels === 'roulettes' ? colorData.roulettesPrice : colorData.piedsPrice;
      var isPreorder = wheels === 'roulettes' ? colorData.roulettesPreorder : colorData.piedsPreorder;
      var sellingPlanId = wheels === 'roulettes' ? colorData.roulettesSellingPlanId : colorData.piedsSellingPlanId;

      var groupsHtml = '';
      if (model.hasColorToggle) {
        groupsHtml += '<div class="tunnel-card__variant-group-label">' + escapeHtml(t('finition')) + '</div>' +
          ['corten', 'noir'].map(function (key) {
            var otherColorData = model.colors[key];
            var otherPrice = wheels === 'roulettes' ? otherColorData.roulettesPrice : otherColorData.piedsPrice;
            var label = key === 'corten' ? t('corten') : t('noir');
            return '<div class="tunnel-card__variant-option' + (color === key ? ' is-selected' : '') + '" data-value="color|||' + key + '">' + escapeHtml(label + (color === key ? '' : deltaLabel(otherPrice, price))) + '</div>';
          }).join('');
      }
      if (colorData.hasWheelsToggle) {
        groupsHtml += '<div class="tunnel-card__variant-group-label">' + escapeHtml(t('option')) + '</div>' +
          '<div class="tunnel-card__variant-option' + (wheels === 'pieds' ? ' is-selected' : '') + '" data-value="wheels|||pieds">' + escapeHtml(t('pieds') + (wheels === 'pieds' ? '' : deltaLabel(colorData.piedsPrice, price))) + '</div>' +
          '<div class="tunnel-card__variant-option' + (wheels === 'roulettes' ? ' is-selected' : '') + '" data-value="wheels|||roulettes">' + escapeHtml(t('roulettes') + (wheels === 'roulettes' ? '' : deltaLabel(colorData.roulettesPrice, price))) + '</div>';
      }

      var variantSelect = groupsHtml
        ? '<div class="tunnel-card__variant-wrap" data-dropdown data-handle="' + model.handle + '">' +
            '<button type="button" class="tunnel-card__variant" data-dropdown-trigger>' + escapeHtml(t('version')) + '</button>' +
            '<div class="tunnel-card__variant-list" data-dropdown-list hidden>' + groupsHtml + '</div>' +
          '</div>'
        : '';

      return (
        '<div class="tunnel-card' + (colorData.available ? '' : ' is-oos') + (isActive ? ' is-selected' : '') + '" data-handle="' + model.handle + '" role="button" aria-pressed="' + isActive + '">' +
        '<div class="tunnel-card__media">' +
        '<img src="' + escapeHtml(colorImage(colorData, wheels)) + '" data-current-src="' + escapeHtml(colorImage(colorData, wheels)) + '" alt="' + escapeHtml(model.title) + '" loading="eager" decoding="async">' +
        (isPreorder ? renderPreorderBadge(sellingPlanId) : '') +
        '<span class="tunnel-card__mark tunnel-card__mark--radio" aria-hidden="true"></span>' +
        '</div>' +
        '<div class="tunnel-card__info">' +
        '<p class="tunnel-card__name">' + escapeHtml(cleanProductName(model.title)) + '</p>' +
        '<div class="tunnel-card__row">' +
        '<p class="tunnel-card__price">' + money(price) + '<span class="tunnel-card__price-sep">·</span>' + escapeHtml(extractDiameter(model.title)) + '</p>' +
        variantSelect +
        '</div>' +
        '</div>' +
        '</div>'
      );
    }).join('');

    itemsWrap.querySelectorAll('.tunnel-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-dropdown]')) return;
        if (e.target.closest('[data-info-trigger]')) return;
        selectBrasero(card.getAttribute('data-handle'));
        syncBraseroCards();
        updateFooter();
        renderVisual();
      });

      var wrap = card.querySelector('[data-dropdown]');
      if (wrap) {
        bindDropdown(wrap, function (composite) {
          var parts = composite.split('|||');
          var handle = wrap.getAttribute('data-handle');
          selectBrasero(handle, parts[0] === 'color' ? { color: parts[1] } : { wheels: parts[1] });
          syncBraseroCards();
          updateFooter();
        });
      }
    });

    bindPreorderInfo(itemsWrap);
  }

  function isSelected(variantId) {
    return state.selections.has(variantId);
  }

  function toggleSelection(item, categoryKey, checked) {
    if (checked) {
      state.selections.set(item.variantId, {
        qty: 1,
        category: categoryKey,
        title: item.title,
        image: item.image,
        price: item.price,
        locked: item.locked,
        productHandle: item.productHandle,
        variantTitle: item.variantTitle || '',
        sellingPlanId: item.sellingPlanId
      });
      pushToStack(item.variantId, item.image, item.title);
      maybeShowPreorderNotice(item);
    } else {
      state.selections.delete(item.variantId);
      removeFromStack(item.variantId);
    }
  }

  function renderAccessoryStep(categoryKey) {
    itemsWrap.className = 'tunnel-screen__items';
    var colorData = currentColorData();
    var items = colorData ? categoryItems(colorData, categoryKey) : [];

    if (!items.length) {
      itemsWrap.innerHTML = '<p>' + escapeHtml(t('empty_category')) + '</p>';
      return;
    }

    itemsWrap.innerHTML = items.map(function (item, i) {
      var hasVariantSelect = Array.isArray(item.variants) && item.variants.length > 1;
      var activeId = hasVariantSelect ? (state.activeVariant[item.productHandle] || String(item.variantId)) : String(item.variantId);
      var activeVariant = hasVariantSelect
        ? ((item.variants || []).find(function (v) { return String(v.id) === String(activeId); }) || item)
        : item;
      var activePrice = activeVariant.price;
      var activePreorder = hasVariantSelect ? activeVariant.preorder : item.preorder;
      var activeSellingPlanId = hasVariantSelect ? activeVariant.sellingPlanId : item.sellingPlanId;
      var activeImage = (hasVariantSelect && activeVariant.image) ? activeVariant.image : item.image;

      var checked = isSelected(activeId);
      var disabled = !item.available;

      var variantSelect = '';
      if (hasVariantSelect) {
        var groups = optionGroups(item.variants);
        var activeMap = variantOptionsMap(activeVariant);
        var groupsHtml = groups.map(function (group) {
          return '<div class="tunnel-card__variant-group-label">' + escapeHtml(group.name) + '</div>' +
            group.values.map(function (value) {
              var isCurrent = activeMap[group.name] === value;
              var selections = Object.assign({}, activeMap);
              selections[group.name] = value;
              var candidate = findVariantByOptions(item.variants, selections) || activeVariant;
              var text = value + (isCurrent ? '' : deltaLabel(candidate.price, activePrice));
              var candidateDisabled = !candidate.available;
              return '<div class="tunnel-card__variant-option' + (isCurrent ? ' is-selected' : '') + '" data-value="' + escapeHtml(group.name + '|||' + value) + '"' + (candidateDisabled ? ' aria-disabled="true"' : '') + '>' + escapeHtml(text) + '</div>';
            }).join('');
        }).join('');
        variantSelect =
          '<div class="tunnel-card__variant-wrap" data-dropdown>' +
          '<button type="button" class="tunnel-card__variant" data-dropdown-trigger>' + escapeHtml(t('version')) + '</button>' +
          '<div class="tunnel-card__variant-list" data-dropdown-list hidden>' + groupsHtml + '</div>' +
          '</div>';
      }

      return (
        '<div class="tunnel-card' + (disabled ? ' is-oos' : '') + (checked ? ' is-selected' : '') + '" data-idx="' + i + '" data-variant-id="' + activeId + '" role="button" aria-pressed="' + checked + '">' +
        '<div class="tunnel-card__media">' +
        '<img src="' + escapeHtml(activeImage) + '" alt="' + escapeHtml(item.title) + '" loading="eager" decoding="async">' +
        (activePreorder ? renderPreorderBadge(activeSellingPlanId) : '') +
        '<span class="tunnel-card__mark" aria-hidden="true"></span>' +
        '</div>' +
        '<div class="tunnel-card__info">' +
        '<p class="tunnel-card__name">' + escapeHtml(cleanProductName(item.title)) + '</p>' +
        '<div class="tunnel-card__row">' +
        '<p class="tunnel-card__price">' + money(activePrice) + '</p>' +
        variantSelect +
        '</div>' +
        (disabled ? '<p class="tunnel-card__stock">' + escapeHtml(t('out_of_stock')) + '</p>' : '') +
        '</div>' +
        '</div>'
      );
    }).join('');

    itemsWrap.querySelectorAll('.tunnel-card').forEach(function (card) {
      var idx = Number(card.getAttribute('data-idx'));
      var item = items[idx];
      var dropdownWrap = card.querySelector('[data-dropdown]');
      var lastClickAt = 0;

      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-dropdown]')) return;
        if (e.target.closest('[data-info-trigger]')) return;
        if (!item || !item.available) return;

        var now = Date.now();
        if (now - lastClickAt < 300) return;
        lastClickAt = now;

        var variantId = card.getAttribute('data-variant-id');
        var hasVariantSelect = Array.isArray(item.variants) && item.variants.length > 1;
        var activeVariant = (item.variants || []).find(function (v) { return String(v.id) === String(variantId); }) || item;
        var variantTitle = hasVariantSelect ? variantLabel(activeVariant) : '';
        var variantImage = (hasVariantSelect && activeVariant.image) ? activeVariant.image : item.image;
        var nowChecked = !isSelected(variantId);
        toggleSelection(Object.assign({}, item, { variantId: variantId, price: activeVariant.price, variantTitle: variantTitle, sellingPlanId: activeVariant.sellingPlanId, image: variantImage }), categoryKey, nowChecked);
        card.classList.toggle('is-selected', nowChecked);
        card.setAttribute('aria-pressed', nowChecked);
        requestAnimationFrame(function () { renderVisual(); });
      });

      if (dropdownWrap) {
        bindDropdown(dropdownWrap, function (composite) {
          var parts = composite.split('|||');
          var groupName = parts[0];
          var value = parts.slice(1).join('|||');
          var oldId = card.getAttribute('data-variant-id');
          var wasChecked = isSelected(oldId);

          var oldVariant = (item.variants || []).find(function (v) { return String(v.id) === String(oldId); }) || item;
          var selections = variantOptionsMap(oldVariant);
          selections[groupName] = value;
          var newVariant = findVariantByOptions(item.variants, selections);
          if (!newVariant) return;
          var newId = String(newVariant.id);
          var newImage = newVariant.image || item.image;

          state.activeVariant[item.productHandle] = newId;

          if (wasChecked) {
            state.selections.delete(oldId);
            removeFromStack(oldId);
            state.selections.set(newId, {
              qty: 1,
              category: categoryKey,
              title: item.title,
              image: newImage,
              price: newVariant.price,
              locked: item.locked,
              productHandle: item.productHandle,
              variantTitle: variantLabel(newVariant),
              sellingPlanId: newVariant.sellingPlanId
            });
            pushToStack(newId, newImage, item.title);
            maybeShowPreorderNotice({ sellingPlanId: newVariant.sellingPlanId });
            requestAnimationFrame(function () { renderVisual(); });
          }

          renderAccessoryStep(categoryKey);
        });
      }
    });

    bindPreorderInfo(itemsWrap);
  }

  function renderRecapAccessoryCard(entry) {
    var priceLine = money(entry.price) + (entry.variantTitle ? '<span class="tunnel-card__price-sep">·</span>' + escapeHtml(entry.variantTitle) : '');
    return (
      '<div class="tunnel-card" data-variant-id="' + entry.variantId + '">' +
      '<div class="tunnel-card__media">' +
      '<img src="' + escapeHtml(entry.image) + '" alt="' + escapeHtml(entry.title) + '" loading="lazy" decoding="async">' +
      (entry.sellingPlanId ? renderPreorderBadge(entry.sellingPlanId) : '') +
      '<button type="button" class="tunnel-card__remove" data-recap-remove="' + entry.variantId + '" aria-label="' + escapeHtml(t('remove_prefix', { name: cleanProductName(entry.title) })) + '">' +
      '<svg viewBox="0 0 16 16" width="11" height="11" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>' +
      '</button>' +
      '</div>' +
      '<div class="tunnel-card__info">' +
      '<p class="tunnel-card__name">' + escapeHtml(cleanProductName(entry.title)) + '</p>' +
      '<div class="tunnel-card__row">' +
      '<p class="tunnel-card__price">' + priceLine + '</p>' +
      '<div class="tunnel-card__qty">' +
      '<button type="button" class="tunnel-qty__btn" data-qty-dec="' + entry.variantId + '">−</button>' +
      '<span class="tunnel-qty__val">' + entry.qty + '</span>' +
      '<button type="button" class="tunnel-qty__btn" data-qty-inc="' + entry.variantId + '">+</button>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  function renderBraseroCard(model, colorData, price, qty) {
    var colorLabel = model.hasColorToggle ? ((state.colorMode === 'noir' ? t('noir') : t('corten')) + ' · ') : '';
    var wheelsLabel = state.wheelsMode === 'roulettes' ? t('roulettes') : t('pieds');
    return (
      '<div class="tunnel-card" data-variant-id="brasero">' +
      '<div class="tunnel-card__media">' +
      '<img src="' + escapeHtml(colorImage(colorData, state.wheelsMode)) + '" alt="' + escapeHtml(model.title) + '" loading="lazy" decoding="async">' +
      '</div>' +
      '<div class="tunnel-card__info">' +
      '<p class="tunnel-card__name">' + escapeHtml(cleanProductName(model.title)) + '</p>' +
      '<div class="tunnel-card__row">' +
      '<p class="tunnel-card__price">' + money(price) + '<span class="tunnel-card__price-sep">·</span>' + escapeHtml(colorLabel + wheelsLabel) + '</p>' +
      '<div class="tunnel-card__qty">' +
      '<button type="button" class="tunnel-qty__btn" data-qty-dec="brasero">−</button>' +
      '<span class="tunnel-qty__val">' + qty + '</span>' +
      '<button type="button" class="tunnel-qty__btn" data-qty-inc="brasero">+</button>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  function getRecapColumns() {
  var body = modal.querySelector('.tunnel-modal__body');
  var probe = document.createElement('div');
  probe.className = 'tunnel-screen__items';
  probe.style.cssText = 'height:0;overflow:hidden;visibility:hidden;';
  body.appendChild(probe);
  var cols = getComputedStyle(probe).gridTemplateColumns.split(' ').filter(Boolean).length;
  probe.remove();
  return cols || 3;
}

function renderGroup(label, key, cards) {
  if (!cards.length) return '';
  var recapColumns = getRecapColumns();
  var first = cards.slice(0, recapColumns);
  var rest = cards.slice(recapColumns);
  var expanded = !!state.recapExpanded[key];
  var visible = expanded ? cards : first;

    var toggleHtml = rest.length
      ? (expanded
          ? '<button type="button" class="tunnel-recap__more" data-recap-less="' + key + '">' + escapeHtml(t('see_less')) + '</button>'
          : '<button type="button" class="tunnel-recap__more" data-recap-more="' + key + '">' + escapeHtml(plural(rest.length, 'see_more_single', 'see_more_multi', { count: rest.length })) + '</button>')
      : '';

    return (
      '<div class="tunnel-group" data-recap-group="' + key + '">' +
      '<p class="tunnel-group__title">' + label + '</p>' +
      '<div class="tunnel-screen__items" data-recap-grid="' + key + '">' + visible.join('') + '</div>' +
      toggleHtml +
      '</div>'
    );
  }

  function handleQtyClick(btn) {
    var incId = btn.getAttribute('data-qty-inc');
    var decId = btn.getAttribute('data-qty-dec');
    var id = incId || decId;
    var delta = incId ? 1 : -1;
    var newQty;

    if (id === 'brasero') {
      state.braseroQty = Math.max(1, (state.braseroQty || 1) + delta);
      newQty = state.braseroQty;
    } else {
      var entry = state.selections.get(id);
      if (!entry) return;
      entry.qty = Math.max(1, (entry.qty || 1) + delta);
      newQty = entry.qty;
    }

    var valEl = btn.parentElement.querySelector('.tunnel-qty__val');
    if (valEl) valEl.textContent = newQty;
    updateTotal();
  }

  function bindRecapCard(card) {
    var removeBtn = card.querySelector('[data-recap-remove]');
    if (removeBtn) {
      removeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        removeRecapEntry(removeBtn.getAttribute('data-recap-remove'), card);
      });
    }
    card.querySelectorAll('.tunnel-qty__btn').forEach(function (btn) {
      btn.addEventListener('click', function () { handleQtyClick(btn); });
    });
    bindPreorderInfo(card);
  }

  function bindMoreButton(btn, category) {
    btn.addEventListener('click', function () {
      state.recapExpanded[category] = !state.recapExpanded[category];
      syncCategoryGroup(category);
    });
  }

  function syncCategoryGroup(category) {
    var cards = [];
    state.selections.forEach(function (entry, variantId) {
      if (entry.category === category) cards.push(Object.assign({ variantId: variantId }, entry));
    });

    var group = itemsWrap.querySelector('[data-recap-group="' + category + '"]');
    if (!cards.length) {
      if (group) group.remove();
      return;
    }
    if (!group) return;

    var grid = group.querySelector('[data-recap-grid="' + category + '"]');
    var recapColumns = getRecapColumns();
    var expanded = !!state.recapExpanded[category];
    var visibleCount = expanded ? cards.length : Math.min(recapColumns, cards.length);
    var shownCount = grid ? grid.children.length : 0;

    if (grid && shownCount < visibleCount) {
      cards.slice(shownCount, visibleCount).forEach(function (entry) {
        grid.insertAdjacentHTML('beforeend', renderRecapAccessoryCard(entry));
        bindRecapCard(grid.lastElementChild);
      });
    } else if (grid && shownCount > visibleCount) {
      while (grid.children.length > visibleCount) {
        grid.removeChild(grid.lastElementChild);
      }
    }

    var rest = Math.max(0, cards.length - recapColumns);
    var moreBtn = group.querySelector('.tunnel-recap__more');
    if (rest > 0) {
      if (!moreBtn) {
        moreBtn = document.createElement('button');
        moreBtn.type = 'button';
        moreBtn.className = 'tunnel-recap__more';
        group.appendChild(moreBtn);
        bindMoreButton(moreBtn, category);
      }
      moreBtn.textContent = expanded ? t('see_less') : plural(rest, 'see_more_single', 'see_more_multi', { count: rest });
    } else if (moreBtn) {
      moreBtn.remove();
    }
  }

  function removeRecapEntry(variantId, card) {
    var entry = state.selections.get(variantId);
    if (!entry) return;
    var category = entry.category;

    if (card) {
      card.classList.add('is-removing');
      var removeBtn = card.querySelector('[data-recap-remove]');
      if (removeBtn) removeBtn.disabled = true;
    }

    setTimeout(function () {
      state.selections.delete(variantId);
      removeFromStack(variantId);
      if (card && card.parentElement) card.remove();
      syncCategoryGroup(category);
      updateTotal();
      renderVisual();
    }, 180);
  }

  function renderRecapStep() {
    itemsWrap.className = 'tunnel-screen__items-recap';
    var brasero = currentBrasero();
    if (!brasero) {
      itemsWrap.innerHTML = '<p>' + escapeHtml(t('empty_recap')) + '</p>';
      return;
    }

    var colorData = currentColorData();
    var braseroPrice = state.wheelsMode === 'roulettes' ? colorData.roulettesPrice : colorData.piedsPrice;

    var byCategory = { cuisine: [], confort: [], entretien: [] };
    state.selections.forEach(function (entry, variantId) {
      byCategory[entry.category].push(Object.assign({ variantId: variantId }, entry));
    });

    var categoryLabels = { cuisine: STEP_LABELS.cuisine, confort: STEP_LABELS.confort, entretien: STEP_LABELS.entretien };

    var braseroBlock =
      '<div class="tunnel-group">' +
      '<p class="tunnel-group__title">' + escapeHtml(STEP_LABELS.brasero) + '</p>' +
      '<div class="tunnel-screen__items">' + renderBraseroCard(brasero, colorData, braseroPrice, state.braseroQty || 1) + '</div>' +
      '</div>';

    var categoryBlocks = Object.keys(byCategory).map(function (key) {
      var cards = byCategory[key].map(function (entry) {
        return renderRecapAccessoryCard(entry);
      });
      return renderGroup(escapeHtml(categoryLabels[key]), key, cards);
    }).join('');

    itemsWrap.innerHTML = braseroBlock + categoryBlocks;

    itemsWrap.querySelectorAll('.tunnel-card').forEach(function (card) {
      bindRecapCard(card);
    });

    itemsWrap.querySelectorAll('[data-recap-more], [data-recap-less]').forEach(function (btn) {
      var category = btn.getAttribute('data-recap-more') || btn.getAttribute('data-recap-less');
      bindMoreButton(btn, category);
    });

    updateTotal();
  }

  function computeTotal() {
    var colorData = currentColorData();
    if (!colorData) return 0;
    var braseroPrice = state.wheelsMode === 'roulettes' ? colorData.roulettesPrice : colorData.piedsPrice;
    var total = braseroPrice * (state.braseroQty || 1);
    state.selections.forEach(function (entry) {
      total += entry.price * (entry.qty || 1);
    });
    return total;
  }

  var DISCOUNT_TIERS = [
    { minUniqueProducts: 4, percent: 5 },
    { minUniqueProducts: 7, percent: 10 },
    { minUniqueProducts: 10, percent: 15 }
  ];

  function selectedUniqueProductCount() {
    return (state.braseroHandle ? 1 : 0) + state.selections.size;
  }

  function discountTierInfo() {
    var count = selectedUniqueProductCount();
    var current = null;
    var next = null;
    DISCOUNT_TIERS.forEach(function (tier) {
      if (count >= tier.minUniqueProducts) current = tier;
      else if (!next) next = tier;
    });
    return { count: count, current: current, next: next };
  }

  function updateDiscountHint() {
    if (!discountHintEl) return;
    var brasero = currentBrasero();
    var info = discountTierInfo();

    if (!brasero) {
      discountHintEl.hidden = true;
      return;
    }

    var accessoryCount = state.selections.size;
    var finalThreshold = DISCOUNT_TIERS[DISCOUNT_TIERS.length - 1].minUniqueProducts - 1;

    if (!info.next) {
      discountLabelEl.textContent = t('discount_reached', { percent: info.current.percent });
    } else {
      var nextAccessoryThreshold = info.next.minUniqueProducts - 1;
      var remaining = nextAccessoryThreshold - accessoryCount;
      var shortText = plural(remaining, 'discount_remaining_short_single', 'discount_remaining_short_multi', { count: remaining, percent: info.next.percent });
      var fullText = plural(remaining, 'discount_remaining_full_single', 'discount_remaining_full_multi', { count: remaining, percent: info.next.percent });
      discountLabelEl.innerHTML =
        '<span class="tunnel-discount-hint__short">' + escapeHtml(shortText) + '</span>' +
        '<span class="tunnel-discount-hint__full">' + escapeHtml(fullText) + '</span>';
    }

    var pct = finalThreshold > 0 ? Math.max(0, Math.min(100, (accessoryCount / finalThreshold) * 100)) : 0;
    discountFillEl.style.width = pct + '%';

    if (discountMilestonesEl) {
      discountMilestonesEl.innerHTML = DISCOUNT_TIERS.map(function (tier, i) {
        var threshold = tier.minUniqueProducts - 1;
        var leftPct = finalThreshold > 0 ? (threshold / finalThreshold) * 100 : 0;
        var reached = accessoryCount >= threshold;
        var isLast = i === DISCOUNT_TIERS.length - 1;
        var alignStyle = isLast ? 'transform:translate(-100%,-50%);' : 'transform:translate(-50%,-50%);';
        return '<span class="tunnel-discount-hint__milestone' + (reached ? ' is-reached' : '') + '" style="left:' + leftPct + '%;' + alignStyle + '">' + tier.percent + '%</span>';
      }).join('');
    }

    discountHintEl.hidden = false;
  }

  function totalSentence() {
    var braseroCount = state.braseroQty || 1;
    var accessoryCount = 0;
    state.selections.forEach(function (entry) { accessoryCount += entry.qty || 1; });

    var braseroWord = plural(braseroCount, 'brasero_word_single', 'brasero_word_multi');
    var accessoryWord = plural(accessoryCount, 'accessory_word_single', 'accessory_word_multi');

    var rawTotal = computeTotal();
    var tier = discountTierInfo().current;
    var displayTotal = tier ? rawTotal * (1 - tier.percent / 100) : rawTotal;

    var full = t('cart_contains', { count: braseroCount, word: braseroWord });
    if (accessoryCount > 0) {
      full += t('cart_and', { count: accessoryCount, word: accessoryWord });
    }
    full += t('cart_total_full') + '<strong>' + money(displayTotal) + '</strong>';
    if (tier) {
      full += t('cart_discount_full', { percent: tier.percent });
    }

    var short = braseroCount + ' ' + braseroWord;
if (accessoryCount > 0) {
  short += ' + ' + accessoryCount + ' ' + accessoryWord;
}
short += ' · <strong>' + money(displayTotal) + '</strong>';
if (tier) {
  short += t('cart_discount_short', { percent: tier.percent });
}

    return '<span class="tunnel-modal__total-text-full">' + full + '</span>' +
      '<span class="tunnel-modal__total-text-short">' + short + '</span>';
  }

  function updateTotal() {
    if (!totalTextEl) return;
    var brasero = currentBrasero();
    totalTextEl.innerHTML = brasero ? totalSentence() : '&nbsp;';
    updateDiscountHint();
  }

  function resetScroll() {
    var panel = modal.querySelector('.tunnel-modal__panel');
    if (panel) panel.scrollTop = 0;
    var body = modal.querySelector('.tunnel-modal__body');
    if (body) body.scrollTop = 0;
  }

  function renderStep() {
    var key = currentStepKey();
    var panel = modal.querySelector('.tunnel-modal__panel');

    if (panel) panel.classList.add('is-step-fading');

    window.setTimeout(function () {
      resetScroll();
      if (headlineEl) headlineEl.textContent = STEP_HEADLINES[key];
      updateProgress();
      renderVisual();

      if (key === 'brasero') renderBraseroStep();
      else if (key === 'recap') renderRecapStep();
      else renderAccessoryStep(key);

      updateFooter();

      if (panel) panel.classList.remove('is-step-fading');
    }, 130);
  }

  function updateFooter() {
    var key = currentStepKey();
    renderBreadcrumb();
    updateTotal();

    if (key === 'recap') {
      btnPrev.hidden = false;
      adaptPrevLabel();
      btnPrev.disabled = !state.braseroHandle;
      btnNext.textContent = t('checkout');
      btnNext.disabled = !state.braseroHandle;
      return;
    }

    btnPrev.hidden = true;
    btnNext.textContent = t('continue');
    btnNext.disabled = (key === 'brasero') && !state.braseroHandle;
  }

  function buildCartItems() {
    var colorData = currentColorData();
    if (!colorData) return [];

    var braseroVariantId = state.wheelsMode === 'roulettes' ? colorData.roulettesVariantId : colorData.piedsVariantId;
    var braseroSellingPlanId = state.wheelsMode === 'roulettes' ? colorData.roulettesSellingPlanId : colorData.piedsSellingPlanId;
    var braseroLine = { id: Number(braseroVariantId), quantity: state.braseroQty || 1 };
    if (braseroSellingPlanId) braseroLine.selling_plan = Number(braseroSellingPlanId);
    var items = [braseroLine];

    state.selections.forEach(function (entry, variantId) {
      var line = { id: Number(variantId), quantity: entry.qty || 1 };
      if (entry.sellingPlanId) line.selling_plan = Number(entry.sellingPlanId);
      items.push(line);
    });

    return items;
  }

  function localizedUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function addToCart(redirectTo) {
    if (isAdding) return;
    var items = buildCartItems();
    if (!items.length) return;

    isAdding = true;
    modal.classList.add('tunnel-is-adding');
    btnPrev.disabled = true;
    btnNext.disabled = true;

    items.forEach(function (line) {
      if (!line.selling_plan) return;
      var props = preorderPropertiesForPlan(line.selling_plan);
      if (props) line.properties = props;
    });

    fetch(localizedUrl('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart add failed');
        window.location.assign(localizedUrl(redirectTo));
      })
      .catch(function () {
        itemsWrap.insertAdjacentHTML('afterbegin', '<p style="color:#b00020;font-weight:600;">' + escapeHtml(t('add_error')) + '</p>');
      })
      .finally(function () {
        isAdding = false;
        modal.classList.remove('tunnel-is-adding');
        btnPrev.disabled = false;
        btnNext.disabled = false;
      });
  }

  if (preorderNoticeCloseBtn) {
    preorderNoticeCloseBtn.addEventListener('click', closePreorderNotice);
  }

  btnPrev.addEventListener('click', function (e) {
    e.preventDefault();
    if (isAdding) return;
    if (!isRecap()) return;
    addToCart('/cart');
  });

  btnNext.addEventListener('click', function (e) {
    e.preventDefault();
    if (isAdding) return;
    if (isRecap()) {
      addToCart('/checkout');
      return;
    }
    if (state.stepIndex < STEP_KEYS.length - 1) {
      state.stepIndex += 1;
      renderStep();
    } else {
      closeModal();
    }
  });

  function openModal() {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('tunnel-open');

    state.stepIndex = 0;
    state.braseroHandle = null;
    state.colorMode = 'corten';
    state.wheelsMode = 'pieds';
    state.braseroQty = 1;
    state.selections.clear();
    state.stack = [];
    state.recapExpanded = {};
    state.activeVariant = {};
    state.preorderNoticeShown = false;

    renderStep();

    requestAnimationFrame(function () {
      var closeBtn = modal.querySelector('[data-tunnel-close]');
      if (closeBtn) closeBtn.focus();
    });
  }

  function closeModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.classList.remove('tunnel-open');
    if (lastOpener) lastOpener.focus();
    lastOpener = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pack-configurator-open]');
    if (opener) {
      lastOpener = opener;
      openModal();
      return;
    }
    if (e.target.closest('[data-tunnel-close]')) closeModal();
    if (!e.target.closest('[data-dropdown]')) closeAllDropdowns();
    if (!e.target.closest('[data-info-trigger]')) closeAllInfoTooltips();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (preorderNotice && !preorderNotice.hidden) { closePreorderNotice(); return; }
    if (!modal.hidden) closeModal();
  });
})();